module.exports = __webpack_public_path__ + "assets/img/kloner_logo_black.53573f1c.svg";